import React from "react";
import { styled } from "@mui/material/styles";
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { PrettyJson } from "./PrettyJson";

const StyledTableCell = styled(TableCell)(() => ({
  borderBottom: "none",
  verticalAlign: "top",
}));

const StyledTable = styled(Table)(() => ({
  tableLayout: "fixed",
  wordWrap: "break-word",
}));

const StyledPaper = styled(Paper)(() => ({
  marginTop: "40px",
  marginBottom: "40px",
}));

const AlternatingRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

// '{ readonly k: string | null | undefined; readonly v: string | null | undefined; } | null | undefined
export interface KeyValueTableProps {
  header: string;
  readonly data?: ReadonlyArray<ArgumentKeyValuePair | null> | null;
  strong?: boolean;
  style?: React.CSSProperties;
}

export type ArgumentKeyValuePair =
  | {
      readonly k: string | null | undefined;
      readonly v: string | null | undefined;
    }
  | null
  | undefined;

const KeyValueTable: React.FC<KeyValueTableProps> = ({ header, data, strong, style }: KeyValueTableProps) => {
  return (
    <StyledPaper style={style}>
      <StyledTable stickyHeader size="small">
        <TableHead>
          <AlternatingRow>
            <TableCell colSpan={2}>{strong ? <strong>{header}</strong> : header}</TableCell>
          </AlternatingRow>
        </TableHead>
        <TableBody>
          {data?.map((kv) => (
            <AlternatingRow key={kv?.k}>
              <StyledTableCell>{kv?.k}</StyledTableCell>
              <StyledTableCell>
                <PrettyJson json={kv?.v} />
              </StyledTableCell>
            </AlternatingRow>
          ))}
        </TableBody>
      </StyledTable>
    </StyledPaper>
  );
};

export default KeyValueTable;
